// Vendors
import React from 'react';
// Containers
import { ContractContainer } from 'containers/contract/contract.container';
import { GetStateContainer } from 'containers/get-state/get-state.container';
import { KycContainer } from 'containers/kyc/kyc.container';
import { PaymentContainer } from 'containers/payment/payment.container';
import { ProofIncomeContainer } from 'containers/proof-income/proof-income.container';
import { SignedContainer } from 'containers/signed/signed.container';
import { UploadIdContainer } from 'containers/upload-id/upload-id.container';
// Components
import { EntrypointOrchestratorUncategorizedComponent } from './components/uncategorized/entrypoint-orchestrator-uncategorized.component';
// Contexts
import { useAppContextConsumerHook } from 'contexts/app.context';
// Utilities
import {
  isContractPage,
  isGetStateLoadingPage,
  isKYCFlowPage,
  isPaymentPage,
  isProofOfIncomePage,
  isSignedPage,
  isUploadIdFlowPage,
} from './utils/entrypoint-orchestrator.utils';

const EntrypointOrchestratorComponent = (): React.JSX.Element => {
  const { currentState } = useAppContextConsumerHook();

  const ComponentToRender =
    {
      [`${isGetStateLoadingPage(currentState)}`]: GetStateContainer,
      [`${isPaymentPage(currentState)}`]: PaymentContainer,
      [`${isProofOfIncomePage(currentState)}`]: ProofIncomeContainer,
      [`${isKYCFlowPage(currentState)}`]: KycContainer,
      [`${isUploadIdFlowPage(currentState)}`]: UploadIdContainer,
      [`${isContractPage(currentState)}`]: ContractContainer,
      [`${isSignedPage(currentState)}`]: SignedContainer,
    }['true'] || EntrypointOrchestratorUncategorizedComponent;

  return <ComponentToRender />;
};

export { EntrypointOrchestratorComponent };
